import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { default as React } from 'react';
import CancelButton from '../CancelButton';
import PrimaryButton from '../PrimaryButton';
import { globalStyles as styles } from '../style/gstheme';
import TitledTextField from '../TitledTextField';
import { fullySanitiseText } from '../utils/utils';

class RenameTemplateDialog extends React.Component {

    state = {
        name: this.props.text || ""
    };

    handleChange = event => {
        const t = event.target;
        const cleanText = fullySanitiseText(t.value.trimLeft());
        this.setState({ [t.name]: cleanText });
    };

    name = () => this.props.onName(this.state.name);

    render() {

        const { classes, onExitName, title, defaultLang } = this.props;
        const { name } = this.state;

        return (
            <React.Fragment>
                <Dialog
                    data-test="name-template-dialog"
                    open={true}
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    onClose={onExitName}
                    aria-labelledby="name-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="name-dialog-title">{title}</DialogTitle>
                    <DialogContent>
                        <form autoComplete="off" noValidate="novalidate">
                            <TitledTextField
                                dataTest="name"
                                name="name"
                                autoFocus={true}
                                title="Template Title"
                                required={true}
                                text={name}
                                lang={defaultLang}
                                placeholder="Enter title"
                                maxLength={30}
                                onChange={this.handleChange} />
                        </form>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={onExitName} />
                        <PrimaryButton
                            disabled={name === ""}
                            onClick={this.name}>Submit</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

RenameTemplateDialog.propTypes = {
    defaultLang: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string,
    onExitName: PropTypes.func.isRequired,
    onName: PropTypes.func.isRequired
};

export default withStyles(styles)(RenameTemplateDialog);